import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center py-12 text-center" data-testid="payment-cancel-page">
      <Card className="flex w-full flex-col items-center gap-4 p-12">
        <XCircle size={40} className="text-muted-foreground" />
        <h1 className="font-head text-2xl font-bold">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground">No charge was made. You can pick a plan whenever you're ready.</p>
        <div className="mt-2 flex gap-3">
          <Button onClick={() => navigate("/pricing")} data-testid="cancel-back-pricing"
            className="rounded-full bg-primary hover:bg-primary/90">Back to pricing</Button>
          <Button variant="outline" onClick={() => navigate("/dashboard")} className="rounded-full">Dashboard</Button>
        </div>
      </Card>
    </div>
  );
}
